export enum AnalyticsEvents {
  VIEWEDPAGE = "EV_CHARGER - Viewed page",
  CLICKEDBUTTON = "EV_CHARGER - clicked button",
  MIXPANEL_INIT = "EV_CHARGER - MIXPANEL INIT",
}

export enum DataLayerEvent {
  SubmitPostcode = "Submit Postcode",
  SubmitOffStreetParking = "Submit Off Street Parking",
  SubmitCableSetup = "Submit Cable Setup",
  SubmitChargerCustomisation = "Submit Charger Customisation",
  SubmitPersonalDetails = "Submit Personal Details",
}

export enum CookieTypes {
  necessary = "C0001",
  performance = "C0002",
  functional = "C0003",
  targeting = "C0004",
  socialMedia = "C0005",
}

export type Consents = {
  necessary: boolean;
  performance: boolean;
  functional: boolean;
  targeting: boolean;
  socialMedia: boolean;
};
